module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [(_vm.contentsPrice != null && _vm.contentsOverview != null) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "card-contents"
  }, [_c('div', {
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "cover-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.getContentsThumbnailPath(_vm.contentsDetail.contentid, _vm.showScreen),
      "alt": _vm.contentsDetail.content_name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [_c('div', {
    staticClass: "content-name font28"
  }, [_vm._v(_vm._s(_vm.contentsDetail.content_name))]), _vm._v(" "), (_vm.contentsPrice != '0') ? _c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("税込")]), _c('span', {
    staticClass: "font20"
  }, [_vm._v(_vm._s(_vm.contentsPrice))]), _vm._v("円")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.contentsOverview))])]), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('button', {
    on: {
      "click": _vm.buyContents
    }
  }, [_vm._v("購入する")])])])])])]) : _c('div', {
    staticClass: "inner"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ce773dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-4ce773dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/StoreDetail.vue
// module id = 717
// module chunks = 1